//import '@babel/polyfill';
//import './gtm.js'
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
//import { createGtm } from "vue-gtm";    // https://github.com/mib200/vue-gtm
import vuetify from './plugins/vuetify';

import App from './App.vue';
import { router } from './_helpers';
import store from './store';
import axios from 'axios';
import { getApiEndpoint } from './_helpers/runtimeConfig';

Vue.config.productionTip = false;
axios.defaults.baseURL = getApiEndpoint();

//Vue.use(
//    createGtm({
//        id: "GTM-WXNN8K8", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//        queryParams: {
//            // Add url query string when load gtm.js with GTM ID (optional)
//            gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
//            gtm_preview: "env-4",
//            gtm_cookies_win: "x",
//        },
//        defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//        compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//        debug: true, // Whether or not display console logs debugs (optional)
//        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//        ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
//        trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
//    })
//);

/*var vm =*/ new Vue({
    router,
    store,
    vuetify,
    axios,
    render: h => h(App)
}).$mount('#app');

